<template>
  <a v-if="isExternalLink && to" :href="to" target="_blank" v-bind="$attrs">
    <slot/>
  </a>
  <router-link
    v-else-if="to"
    v-slot="{ isExactActive, isActive, href, navigate }"
    :aria-current-value="ariaCurrentValue"
    :replace="replace"
    :to="to"
    custom>
    <a
      :class="getActiveClasses(isActive || $route.path.startsWith($router.resolve(to).path), isExactActive)"
      :href="href"
      v-bind="$attrs"
      @click="navigate">
      <slot/>
    </a>
  </router-link>
  <div v-else>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({ inheritAttrs: false })
</script>

<script lang="ts" setup>
import { computed } from 'vue'

// https://router.vuejs.org/guide/advanced/extending-router-link.html
import { RouteLocationRaw } from 'vue-router'

interface Props {
  activeClass?: string
  ariaCurrentValue?: string
  exactActiveClass?: string
  inactiveClass?: string
  replace?: boolean
  to: string | RouteLocationRaw | undefined
}

const props = defineProps<Props>()

const isExternalLink = computed(() => {
  return typeof props.to === 'string' && props.to.startsWith('http')
})

function getActiveClasses(isActive: boolean, isExactActive: boolean): string[] {
  const classes: string[] = []

  if (isActive || isExactActive) {
    if (isActive && props.activeClass) {
      classes.push(props.activeClass)
    }
    if (isExactActive && props.exactActiveClass) {
      classes.push(props.exactActiveClass)
    }
  }

  if (classes.filter(c => Boolean(c).valueOf()).length === 0 && props.inactiveClass) {
    classes.push(props.inactiveClass)
  }

  return classes
}
</script>
